import { create } from 'zustand';
import { Budget } from '../../../../../@types/budget';

interface SelectedBudgetStore {
  selectedBudget: Budget | null;
  onSelect: (budget: Budget) => void;
  onRemove: () => void;
}

const useSelectedBudget = create<SelectedBudgetStore>(set => ({
  selectedBudget: null,
  onSelect: (budget: Budget) => set({ selectedBudget: budget }),
  onRemove: () => set({ selectedBudget: null }),
}));

export default useSelectedBudget;
